module.exports = __webpack_public_path__ + "img/juangang.8e4cb9b8.png";